import React from 'react';
import styles from './Banner.module.scss';
import { Link } from './Link';

export class Banner extends React.Component<{image:{src:string}, href?:string}>
{
	render()
	{

		console.log(this.props);
		let child = (<img src={this.props.image.src} />);

		if(this.props.href)
		{
			child = (
				<Link href={this.props.href} arrow={false}>{child}</Link>
			);
		}

		return (<div className={styles.container}>
			{child}
		</div>);
	}
}
